(function () {
	const revealEls = document.querySelectorAll('.reveal');

	if (! revealEls.length) {
		return;
	}

	const observer = new IntersectionObserver((entries, obs) => {
		entries.forEach(entry => {
			if (entry.isIntersecting) {
				entry.target.classList.add('active');
				obs.unobserve(entry.target);
			}
		});
	}, { rootMargin: '0px 0px -50px 0px', threshold: 0.12 });

	revealEls.forEach(el => {
		observer.observe(el);
	});

})();